import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import add_icon from "../../assets/images/icons/add-icon.png";
// import bottom_image from '../../assets/images/bottom-image.png'

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: 12,
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: 10,
    color: theme.palette.text.secondary,
  },
}));

const Accordions = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignSelf: "center",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: 0,
      }}
    >
      <p
        style={{
          fontSize: 22,
        }}
      >
        IER Membership Classes
      </p>

      <div className={classes.root}>
        <div className="d-flex">
          <div
            className="d-flex"
            style={{ flexDirection: "column", width: "50%" }}
          >
            <Accordion
              expanded={expanded === "panel4"}
              onChange={handleChange("panel4")}
              style={{
                backgroundClip: "#E8F3ED",
                boxShadow: "none",
                marginBottom: 5,
              }}
            >
              <AccordionSummary
                //  expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                style={{
                  backgroundColor: "#0E348A",
                }}
              >
                <div className="d-flex" className="accordion-header">
                  <span className="membership-accordion-title">
                    Graduate Engineer Class Of Membership
                  </span>
                  <img src={add_icon} style={{ width: 20, height: 20 }} />
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <span style={{ borderBottom: "1px solid black" }}>
                    <b>APPLICATION REQUIREMENTS</b>
                  </span>{" "}
                  <br /> <br />
                  <span className="accordion-content-text">
                    Below are the mandatory application requirements needed to
                    be registered in this category:
                  </span>
                  <ol>
                    <li>
                      1. All applicants must have below 2 years of experience
                      after graduation
                    </li>
                    <li>2. A Passport-size photo in PNG or JPG image format</li>
                    <li>
                      3. A Scanned copy of a National ID or Passport in PNG or
                      JPG image format
                    </li>
                    <li>
                      4. A Soft copy of a signed Career Statement or CV in PDF
                      format
                    </li>
                    <li>
                      5. A Scanned copy of a Notarized Bachelor Degree (A0) in
                      PNG or JPG Image format
                    </li>
                    <li>
                      6. A scanned copy of a Bank pay slip of{" "}
                      <b>non-refundable application fees</b> of{" "}
                      <b>Rwf 20,000</b> payable on Account No:{" "}
                      <b>211-131222-1-5118-0</b> under the names of{" "}
                      <b>Institute of Engineers Rwanda</b> in{" "}
                      <b>GT Bank (Rwanda) Plc</b> or MoMo pay{" "}
                      <b>*182*8*1*003884#</b>
                    </li>
                  </ol>
                  <span className="accordion-content-text">Note:</span>
                  <ol>
                    <li>
                      After being admitted as a Graduate Engineer; an annual
                      membership fee amounting to <b>Rwf 20,000</b> is required;
                      a Membership Certificate is provided thereafter.
                    </li>
                  </ol>
                </div>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel6"}
              onChange={handleChange("panel6")}
              style={{
                backgroundClip: "#E8F3ED",
                boxShadow: "none",
                marginBottom: 5,
              }}
            >
              <AccordionSummary
                //  expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                style={{
                  backgroundColor: "#0E348A",
                }}
              >
                <div className="d-flex" className="accordion-header">
                  <span className="membership-accordion-title">
                    Professional Technologist Class Of Membership
                  </span>
                  <img src={add_icon} style={{ width: 20, height: 20 }} />
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <span style={{ borderBottom: "1px solid black" }}>
                    <b>APPLICATION REQUIREMENTS</b>
                  </span>{" "}
                  <br /> <br />
                  <span className="accordion-content-text">
                    Below are the mandatory application requirements needed to
                    be registered in this category:
                  </span>
                  <ol>
                    <li>
                      1. All applicants are required to have a proven
                      professional experience of more than 2 years after
                      graduation
                    </li>
                    <li>2. Passport-size photo in PNG of JPG Image format</li>
                    <li>
                      3. Scanned copy of National ID or Passport in PNG or JPG
                      image format
                    </li>
                    <li>
                      4. Scanned copy of Notarized Advanced Diploma (A1) in PNG
                      or JPG Image format
                    </li>
                    <li>
                      5. Soft copy of a signed Career Statement or CV in PDF
                      format
                    </li>
                    <li>
                      6. A scanned copy of a Bank pay slip (to be submitted as
                      an attachment through the Membership Portal) of{" "}
                      <b>non-refundable application fees</b> amounting to{" "}
                      <b>Rwf 10,000</b> payable on Account No:{" "}
                      <b>211-131222-1-5118-0</b> under the names of{" "}
                      <b>Institute of Engineers Rwanda</b> in{" "}
                      <b>GT Bank (Rwanda) Plc</b> or through MoMo pay{" "}
                      <b>*182*8*1*003884#</b>
                    </li>
                  </ol>
                  <span className="accordion-content-text">Note:</span>
                  <ol>
                    <li>
                      After being admitted as a Professional Technologist with
                      the Institution of Engineers Rwanda, an annual membership
                      fee of <b>Rwf 100,000</b> is required through the same
                      payment modalities as provided above. A Practicing License
                      is issued, thereafter.
                    </li>
                  </ol>
                </div>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel7"}
              onChange={handleChange("panel7")}
              style={{
                boxShadow: "none",
                marginBottom: 5,
              }}
            >
              <AccordionSummary
                //  expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                style={{
                  backgroundColor: "#0E348A",
                }}
                id="panel1bh-header"
              >
                <div className="d-flex" className="accordion-header">
                  <span className="membership-accordion-title">
                    Consulting Firm Class of Membership
                  </span>
                  <img src={add_icon} style={{ width: 20, height: 20 }} />
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <span style={{ borderBottom: "1px solid black" }}>
                    <b>APPLICATION REQUIREMENTS</b>
                  </span>{" "}
                  <br /> <br />
                  <span className="accordion-content-text">
                    Below are the mandatory application requirements needed to
                    be registered in this category:
                  </span>
                  <ol>
                    <li>1. RDB Registration Certificate</li>
                    <li>2. Managing/Technical Director’s Practicing License</li>
                    <li>3. Resume/CV of the Managing/Technical Director</li>
                    <li>4. Company Profile that includes the Office Address</li>
                    <li>5. RSSB Certificate</li>
                    <li>6. RRA Tax Clearance Certificate</li>
                    <li>
                      7. A scanned copy of a Bank pay slip of{" "}
                      <b>non-refundable application fees</b> amounting to{" "}
                      <b>Rwf 100,000</b> payable on Account No:{" "}
                      <b>211-131222-1-5118-0</b> under the names of{" "}
                      <b>Institute of Engineers Rwanda</b> in{" "}
                      <b>GT Bank (Rwanda) Plc</b> (provide the Bank slip as an
                      attachment through the Membership Portal) or through MoMo
                      pay <b>*182*8*1*003884#</b>
                    </li>
                  </ol>
                  <span className="accordion-content-text">Note:</span>
                  <br />
                  <ul>
                    <li>
                      After being admitted as a Consulting Firm with the
                      Institution of Engineers Rwanda, the Firm is required to
                      pay an annual membership fee of <b>Rwf 500,000</b> once
                      registered as a Local Company, and <b>USD 500</b> once
                      registered as a Foreign Company. The fees shall be paid to
                      IER bank account or Momo code indicated above; a
                      Membership Certificate is provided thereafter.
                    </li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
          <div
            className="d-flex"
            style={{ flexDirection: "column", marginLeft: 20, width: "50%" }}
          >
            <Accordion
              expanded={expanded === "panel5"}
              onChange={handleChange("panel5")}
              style={{
                backgroundClip: "#E8F3ED",
                boxShadow: "none",
                marginBottom: 5,
              }}
            >
              <AccordionSummary
                //  expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                style={{
                  backgroundColor: "#0E348A",
                }}
              >
                <div className="d-flex" className="accordion-header">
                  <span className="membership-accordion-title">
                    Graduate Technologist Class Of Membership
                  </span>
                  <img src={add_icon} style={{ width: 20, height: 20 }} />
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <span style={{ borderBottom: "1px solid black" }}>
                    <b>APPLICATION REQUIREMENTS</b>
                  </span>{" "}
                  <br /> <br />
                  <span className="accordion-content-text">
                    Below are the mandatory application requirements needed to
                    be registered in this category:
                  </span>
                  <ol>
                    <li>
                      1. All applicants must have below 2 years of experience
                      after graduation
                    </li>
                    <li>2. A Passport-size photo in PNG or JPG image format</li>
                    <li>
                      3. A Scanned copy of a National ID or Passport in PNG or
                      JPG image format
                    </li>
                    <li>
                      4. A Soft copy of a signed Career Statement or CV in PDF
                      format
                    </li>
                    <li>
                      5. A Scanned copy of a Notarized Advanced Diploma (A1) in
                      PNG or JPG Image format.
                    </li>
                    <li>
                      6. A scanned copy of a Bank pay slip of{" "}
                      <b>non-refundable application fees</b> amounting to{" "}
                      <b>Rwf 10,000</b> payable on Account No:{" "}
                      <b>211-131222-1-5118-0</b> under the names of{" "}
                      <b>Institute of Engineers Rwanda</b> in{" "}
                      <b>GT Bank (Rwanda) Plc</b> or through MoMo pay{" "}
                      <b>*182*8*1*003884#</b>
                    </li>
                  </ol>
                  <span className="accordion-content-text">Note:</span>
                  <br />
                  <ul>
                    <li>
                      After being admitted as a Graduate Technologist; an annual
                      membership fee amounting to <b>Rwf 10,000</b> is required;
                      a Membership Certificate is provided thereafter.
                    </li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel66"}
              onChange={handleChange("panel66")}
              style={{
                backgroundClip: "#E8F3ED",
                boxShadow: "none",
                marginBottom: 5,
              }}
            >
              <AccordionSummary
                //  expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                style={{
                  backgroundColor: "#0E348A",
                }}
              >
                <div className="d-flex" className="accordion-header">
                  <span className="membership-accordion-title">
                    Technician Class Of Membership
                  </span>
                  <img src={add_icon} style={{ width: 20, height: 20 }} />
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <span style={{ borderBottom: "1px solid black" }}>
                    <b>APPLICATION REQUIREMENTS</b>
                  </span>{" "}
                  <br /> <br />
                  <span className="accordion-content-text">
                    Below are the mandatory application requirements needed to
                    be registered in this category:
                  </span>
                  <ol>
                    <li>1. Passport-size photo in PNG of JPG Image format</li>
                    <li>
                      2. Scanned copy of National ID or Passport in PNG or JPG
                      image format
                    </li>
                    <li>
                      3. Scanned copy of Notarized Diploma Certificate(A2) in
                      PNG or JPG Image format{" "}
                    </li>
                    <li>
                      4. Soft copy of a signed Career Statement or CV in PDF
                      format
                    </li>
                    <li>
                      5. A scanned copy of a Bank pay slip (to be submitted as
                      an attachment through the Membership Portal) of{" "}
                      <b>non-refundable application fees</b> amounting to{" "}
                      <b>Rwf 10,000</b> payable on Account No:{" "}
                      <b>211-131222-1-5118-0</b> under the names of{" "}
                      <b>Institute of Engineers Rwanda</b> in{" "}
                      <b>GT Bank (Rwanda) Plc</b> or through MoMo pay{" "}
                      <b>*182*8*1*003884#</b>
                    </li>
                  </ol>
                  <span className="accordion-content-text">Note:</span>
                  <br />
                  <ul>
                    <li>
                      After being admitted as a Technician with the Institution
                      of Engineers Rwanda, an annual membership fee of{" "}
                      <b>Rwf 50,000</b> is required through the same payment
                      modalities as provided above. A Practicing License is
                      issued, thereafter.
                    </li>
                  </ul>
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
              style={{
                boxShadow: "none",
                marginBottom: 5,
              }}
            >
              <AccordionSummary
                //  expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                style={{
                  backgroundColor: "#0E348A",
                }}
              >
                <div className="d-flex" className="accordion-header">
                  <span className="membership-accordion-title">
                    Professional Engineer Class of Membership
                  </span>
                  <img src={add_icon} style={{ width: 20, height: 20 }} />
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <span style={{ borderBottom: "1px solid black" }}>
                    <b>APPLICATION REQUIREMENTS</b>
                  </span>{" "}
                  <br /> <br />
                  <span className="accordion-content-text">
                    Below are the mandatory application requirements needed to
                    be registered in this category:
                  </span>
                  <ol>
                    <li>
                      1. All applicants are required to have a proven
                      professional experience of more than 2 years after
                      graduation
                    </li>
                    <li>2. A Passport-size photo in PNG or JPG Image format</li>
                    <li>
                      3. A Scanned copy of a National ID or Passport in PNG or
                      JPG image format
                    </li>
                    <li>
                      4. A Scanned copy of Notarized Diploma Certificate(A0) in
                      PNG or JPG Image format
                    </li>
                    <li>
                      5. A Soft copy of a signed Career Statement or CV in PDF
                      format
                    </li>
                    <li>
                      6. A Soft copy of an endorsed, signed, and stamped (by a
                      Supervisor) copy of a Technical Report
                    </li>
                    <li>
                      7. A Foreign Practicing License{" "}
                      <b>(Only for non-Rwandans)</b>
                    </li>
                    <li>
                      8. Scanned copy of Notarized Degree Certificates in PNG or
                      JPG image format
                    </li>
                    <li>
                      9. A scanned copy of a Bank pay slip (to be submitted as
                      an attachment through the Membership Portal) of{" "}
                      <b>non-refundable application fees</b> amounting to{" "}
                      <b>Rwf 20,000</b> payable on Account No:{" "}
                      <b>211-131222-1-5118-0</b> under the names of{" "}
                      <b>Institute of Engineers Rwanda</b> in{" "}
                      <b>GT Bank (Rwanda) Plc</b> or through MoMo pay{" "}
                      <b>*182*8*1*003884#</b>
                    </li>
                  </ol>
                  <span className="accordion-content-text">Note:</span>
                  <ol>
                    <li>
                      1. Degrees from Foreign Countries need an{" "}
                      <b>equivalence certificate</b> from the{" "}
                      <b>High Education Council (HEC)</b>
                    </li>
                    <li>
                      2. After being admitted as a Professional Engineer (PE)
                      with the Institution of Engineers Rwanda, an annual
                      membership fee of <b>Rwf 200,000</b> is required through
                      the same payment modalities as provided above; if the
                      applicant is Rwandan, a member of the{" "}
                      <b>
                        East African Community Countries (Uganda, Kenya,
                        Tanzania)
                      </b>{" "}
                      with which IER has a <b>Mutual Recognition Agreement</b>.
                      A Practicing License is issued, thereafter.
                    </li>
                    <li>
                      3. Nationals of Foreign Countries outside the East African
                      Community and other countries of the East African
                      Community with which IER does not have a Mutual
                      Recognition Agreement with pay <b>USD 500</b> through the
                      payment modalities provided above. A Practicing License is
                      issued, thereafter.
                    </li>
                    <li>
                      4. <b>Exemptions:</b> Applicants with more than 10 years
                      of proven engineering working experience, PhD Holders in
                      related engineering fields, Cabinet appointees with
                      engineering backgrounds, and Military Officers in
                      engineering services, shall be exempted from interview as
                      well as submitting technical reports. However, the
                      applicant shall comply with other requirements indicated
                      above.
                    </li>
                    <li>
                      5. <b>Express application:</b> In case the applicant
                      submits an application that is time- sensitive, he/she
                      shall be required to pay <b>Rwf 200,000</b> non-refundable
                      and shall get a response within two weeks.
                    </li>
                  </ol>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
      {/* <img src={bottom_image} className="mt-4"/> */}
    </div>
  );
};

export default Accordions;
